module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', [_c('p', {
    staticClass: "head_1"
  }, [_c('b', [_vm._v("INTRO")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Arf! I’m Puddles. Sometimes I think you humans don’t have the sense God gave a gopher. You wash too much, and you don’t know a thing about the best place to bury a bone!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But you do have some good qualities: like fingers just right for scratching tummies and opening doors. And you taste almost as good as old shoes! I love my boy Bobby, but his mama’s eyes keep leaking salty water. I think they both need a daddy human to make them happy. As a born sheepdog, I should be able to round one up. In fact, I think the nice one down the street would suit me just fine….")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a8c14e16","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780369700407_Introduction.vue
// module id = 66
// module chunks = 0